import { toast } from 'react-toastify'

type NotificationType = keyof Pick<typeof toast, 'success' | 'warn' | 'error'>

export function showNotification(type: NotificationType, text: string): void {
    toast[type](text)
}
